import React, { useState, useContext, useRef } from "react";
import './inquery.css';
import { LanguageContext } from "../settings/LanguageContext";
import emailjs from "@emailjs/browser";

const Inquery = () => {
  const { lang } = useContext(LanguageContext);
  const formRef = useRef(null); // ADD form ref

  const [date, setDate] = useState("");
  const [duration, setDuration] = useState("");

  const durationsEN = ["3 days","4 days","5 days","6 days","7 days","8 days","9 days","10+ days"];
  const durationsRU = ["3 дня","4 дня","5 дней","6 дней","7 дней","8 дней","9 дней","10+ дней"];
  const durations = lang === "EN" ? durationsEN : durationsRU;

  const text = {
    name: lang === "EN" ? "Name*" : "Имя*",
    adults: lang === "EN" ? "Number of adults*" : "Количество взрослых*",
    children: lang === "EN" ? "Number of children" : "Количество детей",
    travelDate: lang === "EN" ? "Travel Date*" : "Дата поездки*",
    travelDuration: lang === "EN" ? "Travel duration*" : "Продолжительность поездки*",
    email: lang === "EN" ? "Email*" : "Эл. почта*",
    contactNumber: lang === "EN" ? "Contact number (WhatsApp available)" : "Контактный номер (доступен WhatsApp)",
    note: lang === "EN" ? "Note (optional)" : "Примечание (необязательно)",
    placeholders: {
      name: lang === "EN" ? "Your name" : "Ваше имя",
      adults: lang === "EN" ? "Number of adults" : "Количество взрослых",
      children: lang === "EN" ? "Number of children" : "Количество детей",
      email: lang === "EN" ? "Your email" : "Ваш email",
      contact: lang === "EN" ? "Your number" : "Ваш номер",
      note: lang === "EN" ? "Tell us about your project..." : "Расскажите нам о вашем проекте..."
    },
    submit: lang === "EN" ? "Send Message" : "Отправить сообщение"
  };

  // ADD EmailJS handler
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm(
      "service_c49o0vv",      // replace with your EmailJS service ID
      "template_qlf7ox8",     // replace with your EmailJS template ID
      formRef.current,
      "VHyyrBmncbuS5gFPg"       // replace with your EmailJS public key
    ).then(() => {
      alert(lang === "EN" ? "Message sent!" : "Сообщение отправлено!");
      formRef.current.reset();
      setDate("");
      setDuration("");
    }, (error) => {
      console.error(error);
      alert(lang === "EN" ? "Failed to send message 😕" : "Не удалось отправить сообщение 😕");
    });
  };

  return (
    <form ref={formRef} onSubmit={sendEmail} className="main-inq">
      <div className="inq-back-pic-main"></div>

      <div className="inp-personal">
        <div className="inp-row">
          <div className="inp-col">
            <label>{text.name}</label>
            <input
              type="text"
              name="user_name"       // ADD name for EmailJS
              placeholder={text.placeholders.name}
              className="inq-textinp-det"
              required
            />
          </div>
          <div className="inp-col">
            <label>{text.adults}</label>
            <input
              type="number"
              name="adults"          // ADD name
              placeholder={text.placeholders.adults}
              className="inq-textinp-det"
              min={1}
              required
            />
          </div>
          <div className="inp-col">
            <label>{text.children}</label>
            <input
              type="number"
              name="children"        // ADD name
              placeholder={text.placeholders.children}
              className="inq-textinp-det"
              min={0}
            />
          </div>
        </div>
      </div>

      <div className="inp-row">
        <div className="inp-col">
          <label>{text.travelDate}</label>
          <input
            type="date"
            name="travel_date"       // ADD name
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className="inq-textinp-det"
            required
          />
        </div>
        <div className="inp-col">
          <label>{text.travelDuration}</label>
          <div className="duration-buttons">
            {durations.map((d, i) => (
              <button
                key={i}
                type="button"
                className={`day-chose-btn ${duration === d ? "active" : ""}`}
                onClick={() => setDuration(d)}
              >
                {d}
              </button>
            ))}
          </div>
          {/* Hidden field to send selected duration */}
          <input type="hidden" name="duration" value={duration} />
        </div>
      </div>

      <div className="inp-row">
        <div className="inp-col">
          <label>{text.email}</label>
          <input
            type="email"
            name="user_email"        // ADD name
            placeholder={text.placeholders.email}
            className="inq-textinp-det"
            required
          />
        </div>
        <div className="inp-col">
          <label>{text.contactNumber}</label>
          <input
            type="text"
            name="contact_number"     // ADD name
            placeholder={text.placeholders.contact}
            className="inq-textinp-det"
          />
        </div>
      </div>

      <div className="inp-row">
        <div className="inp-col-full">
          <label>{text.note}</label>
          <textarea
            name="note"               // ADD name
            placeholder={text.placeholders.note}
            className="inq-textarea-det"
          />
        </div>
      </div>

      <div className="inp-button">
        <button type="submit">{text.submit}</button>
      </div>
    </form>
  );
};

export default Inquery;
